<template>
  <div class="notification-badge">
    <span class="notification-badge-number">{{badgecount}}</span>
  </div>
</template>

<script>
export default {
  props: {
    badgecount: {
      type: [Number],
      required: false,
      default: null,
    },
  },
  name: 'notification-badge'
}
</script>

<style scoped>
.notification-badge-number {
    padding: 3px;
    display: block;
    text-align: center;
    color: #ffffff;
}

div {
    padding: 0 !important;
    z-index: 100;
    position: absolute;
    left: 60%;
    top: 5%;
    min-height: 20px !important;
    min-width: 20px !important;
    background: #e85e0c !important;
    border-radius: 20px;
}

@media(max-width:767px) {
    div {
        right: 32%;
    }
  }
</style>
